import { Link, usePage } from "@inertiajs/react"

interface ProductionHeaderProps {
  title: string
  subtitle?: string
  paths: {
    admin_root: string
    batches_index: string
    assets_index: string
  }
  storeName?: string
  actions?: React.ReactNode
}

export default function ProductionHeader({
  title,
  subtitle,
  paths,
  actions,
}: ProductionHeaderProps) {
  const { url } = usePage()
  const isActive = (path: string) =>
    url === path || url.startsWith(`${path}/`)

  const tabClass = (path: string) =>
    isActive(path)
      ? "border-b-2 border-gray-900 pb-2 text-sm font-medium text-gray-900"
      : "border-b-2 border-transparent pb-2 text-sm text-gray-500 hover:text-gray-900"

  return (
    <header className="border-b border-gray-200 bg-white">
      <div className="px-6 pt-6">
        <div className="flex items-end justify-between gap-4">
          <div>
            <h1 className="text-2xl font-semibold text-gray-900">{title}</h1>
            {subtitle && <p className="text-sm text-gray-500">{subtitle}</p>}
          </div>
          {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>
        <nav className="mt-4 flex gap-6">
          <Link href={paths.batches_index} className={tabClass(paths.batches_index)}>
            Batches
          </Link>
          <Link href={paths.assets_index} className={tabClass(paths.assets_index)}>
            Équipements
          </Link>
        </nav>
      </div>
    </header>
  )
}
